import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { news } from "@/mocks/news";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import QuickCategories from "@/pages/home/components/QuickCategories";
import NewReleases from "@/pages/home/components/NewReleases";
import HotRecommend from "@/pages/home/components/HotRecommend";
import NewsSection from "@/pages/home/components/NewsSection";

const featured = movies.filter((item) => item.backdrop);

const newReleases = [...movies].sort(
  (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
);

const hotMovies = [...movies]
  .filter((item) => item.type === "movie")
  .sort((a, b) => b.hot - a.hot);

const hotTv = [...movies]
  .filter((item) => item.type === "tv")
  .sort((a, b) => b.hot - a.hot);

const latestNews = [...news].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
);

export default function Home() {
  usePageMeta(
    "后入影视网 - 最新电影电视剧在线播放与资讯",
    "后入影视网提供丰富的电影、电视剧资源，涵盖多类型影视作品，满足用户观影及查询需求，实时更新热门影视资讯。",
    "后入,影视,电影,电视剧,在线播放,影视资讯,影视推荐,影视平台"
  );

  return (
    <div className="pb-16">
      <HeroCarousel items={featured} />

      <div className="-mt-10 relative z-20">
        <QuickCategories />
      </div>

      <NewReleases items={newReleases} />

      <HotRecommend movies={hotMovies} tv={hotTv} />

      <NewsSection items={latestNews} />

      <section className="mx-auto mt-14 w-full px-4 md:px-6">
        <div className="flex flex-col items-start gap-6 rounded-lg bg-primary-950 p-6 md:flex-row md:items-center md:justify-between md:p-10">
          <div className="max-w-2xl">
            <h2 className="font-heading text-xl font-bold text-white md:text-2xl">
              关于后入影视网
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-white/70">
              后入影视网聚焦最新电影、电视剧资源与影视资讯，为影视爱好者提供分类浏览、作品详情、实时资讯与便捷搜索的一站式体验。本站内容均为虚构演示资源，播放功能仅为界面演示，不提供任何真实影音播放与下载。
            </p>
          </div>
          <div className="flex shrink-0 flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-accent-600"
            >
              <i className="ri-compass-3-line"></i>
              浏览影视分类
            </Link>
            <Link
              to="/news"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-white/30 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
            >
              <i className="ri-newspaper-line"></i>
              查看影视资讯
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}